import { Icon, IconSize, Home, Settings, ServerProcesses } from '@soteria/design-system-ve';

import { config } from '../../../config';

import * as styles from './NavigationSlideout.css';

interface NavigationButtonsProps {
  isUserSystemAdmin: boolean;
  hasAdminAccess: boolean;
  onCommunityGroupsClick: () => void;
  onSynesisClick: () => void;
  onSystemConfigClick: () => void;
}

/**
 * Navigation buttons section component
 * Displays Community Groups, Synesis Data Management, and System Configuration buttons
 */
export function NavigationButtons({ isUserSystemAdmin, hasAdminAccess, onCommunityGroupsClick, onSynesisClick, onSystemConfigClick }: NavigationButtonsProps) {
  return (
    <>
      {/* Community Groups Button */}
      <button className={styles.homeButton} onClick={onCommunityGroupsClick}>
        <Icon className={styles.homeIcon} icon={Home} iconSize={IconSize.Small} />
        <span className={styles.homeButtonText}>Community Groups</span>
      </button>

      {/* Synesis Data Management Button - Only visible to system admins and community admins */}
      {config.externalServices.synesisUrl && hasAdminAccess && (
        <button className={styles.systemConfigButton} onClick={onSynesisClick}>
          <Icon className={styles.homeIcon} icon={ServerProcesses} iconSize={IconSize.Small} />
          <span className={styles.homeButtonText}>Synesis Data Management</span>
        </button>
      )}

      {/* System Configuration Button - Only visible to system admins */}
      {isUserSystemAdmin && (
        <button className={styles.systemConfigButton} onClick={onSystemConfigClick}>
          <Icon className={styles.homeIcon} icon={Settings} iconSize={IconSize.Small} />
          <span className={styles.homeButtonText}>System Configuration</span>
        </button>
      )}
    </>
  );
}
